/**
 * 音频系统工具函数
 */

/**
 * 检测浏览器是否支持 AudioContext
 * @returns 是否支持 AudioContext 或 webkitAudioContext
 */
export function isAudioContextSupported(): boolean {
  return typeof window !== 'undefined' ? !!(
    window?.AudioContext ||
    (window as typeof window & { webkitAudioContext?: typeof AudioContext })?.webkitAudioContext
  ) : false;
}

/**
 * 获取 AudioContext 构造函数
 * 优先返回标准的 AudioContext，不支持则返回 webkitAudioContext
 * @returns AudioContext 构造函数，如果不支持则返回 null
 */
export function getAudioContextClass(): typeof AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (window.AudioContext) {
    return window.AudioContext;
  }

  const webkit = (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (webkit) {
    return webkit;
  }

  return null;
}
